<li ngbDropdown class="nav-item dropdown-notification mr-25">
  <a class="nav-link" ngbDropdownToggle id="navbarNotificationDropdown"><i class="ficon" data-feather="bell"></i><span
      class="badge badge-pill badge-danger badge-up" *ngIf="unreadCount > 0">{{ unreadCount }}</span></a>
  <ul ngbDropdownMenu aria-labelledby="navbarNotificationDropdown"
    class="dropdown-menu dropdown-menu-media dropdown-menu-right">
    <!-- Notifications header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">Notifications</h4>
        <div class="badge badge-pill badge-light-primary" *ngIf="unreadCount > 0">
          {{ unreadCount }}
          New
        </div>
      </div>
    </li>
    <!--/ Notifications header -->

    <!-- Notifications content -->
    <li class="scrollable-container media-list" [ngClass]="{'py-2': notifications.length == 0}">
      <a class="d-flex" *ngFor="let notification of notifications" (click)="markAsRead(notification.id)"
        [ngStyle]="{ 'background-color': notification.isReaded ? '' : '#e5e3ff4d' }">

        <div class="media d-flex align-items-start">
          <div class="media-body">
            <p class="media-heading" [innerHTML]="notification.title"></p>
            <small class="notification-text" [innerHTML]="notification.content"></small>
          </div>
        </div>
      </a>
      <h4 class="text-center mb-0" *ngIf="notificationsLoading || notifications.length == 0">
        <span class="text-muted" *ngIf="!notificationsLoading && notifications.length == 0">No notification.</span>
        <span class="spinner-border text-primary" *ngIf="notificationsLoading"></span>
      </h4>
    </li>
    <!--/ Notifications content -->

    <!-- Notifications footer -->
    <li class="dropdown-menu-footer" *ngIf="unreadCount > 0">
      <a class="btn btn-primary btn-block" href="javascript:void(0)" (click)="markAllAsRead()">
        <span class="spinner-border spinner-border-sm text-white" *ngIf="markAllLoading"></span> Mark all as read
      </a>
    </li>
    <!--/ Notifications footer -->
  </ul>
</li>